import Vue from 'vue';



export default Vue.extend({

  name: 'RestQuestionCount',

  props: {
    restQuestionCount: {
      type: Number,
      required: true
    }
  }



});
